import { PrompSaveDirectiveModule } from '@b2b/common/directives/promptSave/promptSave.directive';
import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { FormsCreateControllerModule } from './controllers/FormsCreateController';

export const FormsCreateView = angular
  .module('acme.view.application.forms.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    PrompSaveDirectiveModule,
    'acme.common.directive.spectrum',
    FormsCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.forms.create',
      url: '/create',
      views: {
        'subview-main': {
          controller: 'FormsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/forms/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Form',
        /** Secure With Permissions **/
        permissions: ['FORMS_CREATE'],
      },
      resolve: {
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: ApiService, HelpersService: TODO) {
            return ApiService.form.customFields.list(HelpersService.getPaginator());
          },
        ],
        formBuilder: LoadScriptResolver({ id: 'form-builder-js', url: '/assets/form-builder.min.js' }),
        formBuilderCss: LoadCssResolver({ id: 'form-builder', url: '/assets/form-builder.min.css' }),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.forms.edit',
      url: '/:formId/edit',
      views: {
        'subview-main': {
          controller: 'FormsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/forms/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Form',
        /** Secure With Permissions **/
        permissions: ['FORMS_UPDATE'],
      },
      params: {
        duplicate: null,
        created: null,
      },
      resolve: {
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: ApiService, HelpersService: TODO) {
            return ApiService.form.customFields.list(HelpersService.getPaginator());
          },
        ],
        formBuilder: LoadScriptResolver({ id: 'form-builder-js', url: '/assets/form-builder.min.js' }),
        formBuilderCss: LoadCssResolver({ id: 'form-builder', url: '/assets/form-builder.min.css' }),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.forms.copy',
      url: '/copy',
      views: {
        'subview-main': {
          controller: 'FormsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/forms/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Duplicate Form',
        /** Secure With Permissions **/
        permissions: ['FORMS_CREATE'],
      },
      params: {
        copy: null,
      },
      resolve: {
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: ApiService, HelpersService: TODO) {
            return ApiService.form.customFields.list(HelpersService.getPaginator());
          },
        ],
        formBuilder: LoadScriptResolver({ id: 'form-builder-js', url: '/assets/form-builder.min.js' }),
        formBuilderCss: LoadCssResolver({ id: 'form-builder', url: '/assets/form-builder.min.css' }),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });
  }).name;
